/* tslint:disable */
/* eslint-disable */
/**
 * Onibi Portal Api
 * The API for the OnibiPortal Server project
 *
 * OpenAPI spec version: v1
 * Contact: info@yumebau.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import globalAxios, { AxiosResponse, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
import { TagType } from '../models';
/**
 * TagTypesApi - axios parameter creator
 * @export
 */
export const TagTypesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {TagType} [body] 
         * @param {string} [server] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTagTypesAddOrEditPost: async (body?: TagType, server?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/TagTypes/addOrEdit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (server !== undefined) {
                localVarQueryParameter['server'] = server;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} [server] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTagTypesDeleteIdDelete: async (id: string, server?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling apiTagTypesDeleteIdDelete.');
            }
            const localVarPath = `/api/TagTypes/delete/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (server !== undefined) {
                localVarQueryParameter['server'] = server;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTagTypesGetPortalTaggableTypesGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/TagTypes/get/portalTaggableTypes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [server] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTagTypesListGet: async (server?: string, page?: number, pageSize?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/TagTypes/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (server !== undefined) {
                localVarQueryParameter['server'] = server;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TagTypesApi - functional programming interface
 * @export
 */
export const TagTypesApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {TagType} [body] 
         * @param {string} [server] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTagTypesAddOrEditPost(body?: TagType, server?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>> {
            const localVarAxiosArgs = await TagTypesApiAxiosParamCreator(configuration).apiTagTypesAddOrEditPost(body, server, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} [server] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTagTypesDeleteIdDelete(id: string, server?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>> {
            const localVarAxiosArgs = await TagTypesApiAxiosParamCreator(configuration).apiTagTypesDeleteIdDelete(id, server, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTagTypesGetPortalTaggableTypesGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<Array<any>>>> {
            const localVarAxiosArgs = await TagTypesApiAxiosParamCreator(configuration).apiTagTypesGetPortalTaggableTypesGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} [server] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTagTypesListGet(server?: string, page?: number, pageSize?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<Array<any>>>> {
            const localVarAxiosArgs = await TagTypesApiAxiosParamCreator(configuration).apiTagTypesListGet(server, page, pageSize, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * TagTypesApi - factory interface
 * @export
 */
export const TagTypesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {TagType} [body] 
         * @param {string} [server] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTagTypesAddOrEditPost(body?: TagType, server?: string, options?: AxiosRequestConfig): Promise<AxiosResponse<void>> {
            return TagTypesApiFp(configuration).apiTagTypesAddOrEditPost(body, server, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {string} [server] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTagTypesDeleteIdDelete(id: string, server?: string, options?: AxiosRequestConfig): Promise<AxiosResponse<void>> {
            return TagTypesApiFp(configuration).apiTagTypesDeleteIdDelete(id, server, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTagTypesGetPortalTaggableTypesGet(options?: AxiosRequestConfig): Promise<AxiosResponse<Array<any>>> {
            return TagTypesApiFp(configuration).apiTagTypesGetPortalTaggableTypesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [server] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTagTypesListGet(server?: string, page?: number, pageSize?: number, options?: AxiosRequestConfig): Promise<AxiosResponse<Array<any>>> {
            return TagTypesApiFp(configuration).apiTagTypesListGet(server, page, pageSize, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TagTypesApi - object-oriented interface
 * @export
 * @class TagTypesApi
 * @extends {BaseAPI}
 */
export class TagTypesApi extends BaseAPI {
    /**
     * 
     * @param {TagType} [body] 
     * @param {string} [server] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TagTypesApi
     */
    public async apiTagTypesAddOrEditPost(body?: TagType, server?: string, options?: AxiosRequestConfig) : Promise<AxiosResponse<void>> {
        return TagTypesApiFp(this.configuration).apiTagTypesAddOrEditPost(body, server, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {string} id 
     * @param {string} [server] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TagTypesApi
     */
    public async apiTagTypesDeleteIdDelete(id: string, server?: string, options?: AxiosRequestConfig) : Promise<AxiosResponse<void>> {
        return TagTypesApiFp(this.configuration).apiTagTypesDeleteIdDelete(id, server, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TagTypesApi
     */
    public async apiTagTypesGetPortalTaggableTypesGet(options?: AxiosRequestConfig) : Promise<AxiosResponse<Array<any>>> {
        return TagTypesApiFp(this.configuration).apiTagTypesGetPortalTaggableTypesGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {string} [server] 
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TagTypesApi
     */
    public async apiTagTypesListGet(server?: string, page?: number, pageSize?: number, options?: AxiosRequestConfig) : Promise<AxiosResponse<Array<any>>> {
        return TagTypesApiFp(this.configuration).apiTagTypesListGet(server, page, pageSize, options).then((request) => request(this.axios, this.basePath));
    }
}
